import MenuItem from '@components/v2/ui/Menu/MenuItem';
import SearchableMenuList from '@components/v2/ui/Menu/SearchableMenuList';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { AddOrderProductTestIds } from '../../../../../utils/testIds/OrderProducts.testIds';
import ColorElement from '../../../../products/colors/ColorElement';
import { AddOrderProductColorOption } from './addOrderProductRow.types';

interface AddOrderProductColorMenuProps {
  colors: AddOrderProductColorOption[];
  selectedColorId?: string;
  onSelect: (color: AddOrderProductColorOption) => void;
}

const AddOrderProductColorMenu = ({
  colors,
  selectedColorId,
  onSelect,
}: AddOrderProductColorMenuProps) => {
  return (
    <SearchableMenuList
      items={colors}
      testId={AddOrderProductTestIds.COLOR_SEARCH}
      item={{
        getKey: (color) => color.id,
        getSearchValue: (color) => `${color.code} ${color.name}`,
        onSelect,
        render: (color) => (
          <MenuItem selected={color.id === selectedColorId} onClick={() => onSelect(color)}>
            <Stack direction="row" sx={{ alignItems: 'center', gap: 1, minWidth: 0 }}>
              <ColorElement
                size={1.75}
                isImage={color.isImage}
                hexcode={color.hexcode}
                imageUrl={color.imageUrl}
              />
              <Typography variant="body2" title={`${color.code} - ${color.name}`} noWrap>
                {color.code} - {color.name}
              </Typography>
            </Stack>
          </MenuItem>
        ),
      }}
    />
  );
};

export default AddOrderProductColorMenu;
